// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__cseJm","open":"sidebar_open__3+6P4","navigation":"sidebar_navigation__1Dtkv"};